import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Box, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";

const CommonDateTimePicker = ({
  ele,
  register,
  selectValues,
  handleDisable,
  errors,
  propsData,
  minDate,
  setValue,
  clearErrors,
  formError,
  edit,
}) => {
useEffect(() => {
  if(!edit){
    setValue(ele?.name, dayjs(minDate ? minDate : new Date()))
  }
}, [minDate])

  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);
  return (
    <Box className="customDatepicker">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="dateTimePickerContainer">
        <DateTimePicker
         open={openDateTimePicker}
         onOpen={() => setOpenDateTimePicker(true)}
        onClose={() => setOpenDateTimePicker(false)}
          {...register(ele?.name, {
            required: ele?.required,
          })}
          format="DD/MM/YYYY HH:mm"
          placeholderText="Please select a date"
          skipDisabled={true}
          minutesStep={2}
          defaultValue={
            (selectValues[ele?.name] && dayjs(selectValues[ele?.name]))
          }
          disabled={handleDisable(ele?.fieldDisabled, propsData?.disabled)}
          minDateTime={dayjs(minDate)}
          className="customDatepicker"
          value={minDate && !edit ? dayjs(minDate) : selectValues[ele?.name] ? dayjs(selectValues[ele?.name]) : dayjs(new Date())}
          onChange={(newDate) => {
            clearErrors(ele?.name);
            setValue(ele?.name, newDate);
          }}
          ampm={false}
          renderInput={(params) => (
            <TextField
              {...params}
              error={errors[ele?.name] || formError[ele?.name]}
              inputProps={{
                ...params.inputProps,
              }}
              label="Select Date"
              placeholder="MM/DD/YYYY"
              fullWidth
              required
            />
          )}
        />
        <div
         className="clickableOverlay"
         onClick={() => setOpenDateTimePicker(true)}
         ></div>
        </div>
      </LocalizationProvider>
    </Box>
  );
};

export default CommonDateTimePicker;
